module.exports = __webpack_public_path__ + "static/media/icon-addButton.5cad57aa.svg";